var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-order-handle',{staticClass:"pt-order-handle__page"})}
var staticRenderFns = []

export { render, staticRenderFns }